module.exports = __webpack_public_path__ + "45c4719775634cba6ff0805bdd46d123.pdf";